<template>
    <section class=" h-full  w-full flex flex-wrap bg-gray-50 justify-start  ">

    <!-- Filtros de fecha personalizados -->
    <div class="w-full bg-white p-4 mb-4 shadow-sm border-b">
        <div class="flex flex-wrap gap-4 items-center">
            <!-- Selector de tipo de filtro -->
            <div class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Tipo de filtro:</label>
                <select v-model="tipoFiltroFecha" @change="cambiarTipoFiltro" 
                        class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <option value="mes">Por mes</option>
                    <option value="personalizado">Fechas personalizadas</option>
                </select>
            </div>

            <!-- Filtro por mes -->
            <div v-if="tipoFiltroFecha === 'mes'" class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Seleccionar mes:</label>
                <input type="month" v-model="mesSeleccionado" @change="aplicarFiltroMes" 
                       class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            </div>

            <!-- Filtro personalizado -->
            <div v-if="tipoFiltroFecha === 'personalizado'" class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Fecha inicio:</label>
                <input type="date" v-model="fechaInicioPersonalizada" @change="aplicarFiltroPersonalizado" 
                       class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            </div>

            <div v-if="tipoFiltroFecha === 'personalizado'" class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Fecha fin:</label>
                <input type="date" v-model="fechaFinPersonalizada" @change="aplicarFiltroPersonalizado" 
                       class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            </div>

            <!-- Botones de acciones rápidas -->
            <div class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Acciones rápidas:</label>
                <div class="flex gap-2">
                    <button @click="establecerMesActual" 
                            class="px-3 py-2 bg-blue-500 text-white text-xs rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500">
                        Mes actual
                    </button>
                    <button @click="establecerMesAnterior" 
                            class="px-3 py-2 bg-gray-500 text-white text-xs rounded hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500">
                        Mes anterior
                    </button>
                    <button @click="establecerUltimos3Meses" 
                            class="px-3 py-2 bg-green-500 text-white text-xs rounded hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500">
                        Últimos 3 meses
                    </button>
                </div>
            </div>

            <!-- Mostrar rango actual -->
            <div class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Rango actual:</label>
                <div class="text-sm text-gray-600 bg-gray-100 px-3 py-2 rounded">
                    <span class="font-medium">{{ formatDateES(fechaRango[0]) }}</span> - 
                    <span class="font-medium">{{ formatDateES(fechaRango[1]) }}</span>
                </div>
            </div>
        </div>
    </div>
    
        <!-- Paginación (solo cuando no es móvil) -->
        <div v-if="!IsMov() && data.hasOwnProperty('data')" class="w-full h-12 bg-gray-100 flex flex-wrap content-center justify-start pl-12">
            <div class="">
                <el-pagination v-model:currentPage="pagina" small background layout="prev, pager, next" :page-size="data['per_page']" :total="Number(data['total'])" @current-change="pageChangue" class="" />
            </div>
        </div>
        
        <!-- Paginación móvil -->
        <div v-if="IsMov() && data.hasOwnProperty('data')" class="w-full h-12 bg-gray-100 flex flex-wrap content-center justify-end px-2 ">
            <div class="w-full h-12 justify-center content-center flex flex-wrap ">
                <el-pagination v-model:currentPage="pagina" small background layout="prev, pager, next" :page-size="data['per_page']" :total="Number(data['total'])" @current-change="pageChangue" class="" />
            </div>
        </div>

        <!-- Mostrar tabla cuando hay datos -->
        <Tabla v-bind:key="reftable" v-if="data.hasOwnProperty('data') && data.data.length > 0"  
        :add="false" :columns="headings" :rows="data.data" :filtros="['email','phone','id']" :buscarp="buscar" :filtroApi="true" :paginate="true" :page="{
            page:data.current_page,
            total:data.last_page
          }" />
    
        <!-- Mostrar mensaje cuando no hay datos -->
        <div v-else-if="data.hasOwnProperty('data') && data.data.length === 0" class="w-full h-full flex items-center justify-center">
            <div class="text-center p-8">
                <p class="text-gray-500 text-lg">No hay datos para mostrar</p>
                <p class="text-gray-400 text-sm mt-2">Intenta ajustar los filtros de búsqueda o el rango de fechas</p>
            </div>
        </div>

        <el-drawer @closed="getData()" v-model="viewCotizacion" title="" :with-header="false" :size="$isMobile()?'100%':'100%'">
            <!--content-->
            <div class="h-full    flex flex-wrap content-start justify-center w-full  outline-none focus:outline-none overflow-y-scroll">
                <!--header-->
    
               
                <!--body-->
                <div class="w-full   overflow-y-scroll flex  flex-wrap justify-start  content-start z-20 h-full">
    
                    <div class="h-full bg-white px-2 flex flex-wrap w-full">
                        <div class="h-10 text-black text-base uppercase bg-gray-300 align-middle w-full flex flex-wrap" >
                            <div class="w-3/12 h-10 bg-yellow-300 flex flex-wrap justify-center content-center font-extrabold"><span class="align-middle">#Venta</span></div>
                            <div class="w-3/12 h-10 bg-yellow-200 flex flex-wrap justify-center content-center font-extrabold"><span class="align-middle">{{el_cotizacion.idventa}}</span></div>
                            <div class="w-3/12 h-10 bg-yellow-300 flex flex-wrap justify-center content-center font-extrabold"><span class="align-middle">Cliente</span></div>
                            <div class="w-3/12 h-12 bg-yellow-200 align-middle flex flex-wrap justify-center content-center"><span>{{ el_cotizacion.clientes.name}} {{ el_cotizacion.clientes.apellido_p}} {{ el_cotizacion.clientes.apellido_m}}</span></div>
                         </div>
                        <alert_component tipo="success" title="Panel para aprobación " text="en esta seccion se aprueba el formato de produccion independiente por producto."></alert_component>
              
                        <!--<div class="w-full flex flex-wrap">
                            <span class="text-blue-500">Observaciones de aprobación</span>
                        </div>
                        <textarea class="h-20 text-left w-full px-2 mb-4" v-model="el_cotizacion.observaciones_verificar"></textarea>-->
    
                        <VistaAprobacion v-bind:key="viewCotizacion" :cotizacion="el_cotizacion" :edit="false"></VistaAprobacion>
    
                    </div>
    
                </div>
    
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <!--<a v-if="el_cotizacion.status_verificar=='PENDIENTE DE REVISIÓN'||el_cotizacion.status_verificar=='RECHAZADA'" class=" bg-green-500 text-black  px-2 py-1 rounded border-2  border-black" @click="Verificar('APROBADA')">Aprobar</a>
                    <button v-if="el_cotizacion.status_verificar=='PENDIENTE DE REVISIÓN'||el_cotizacion.status_verificar=='RECHAZADA'" class=" bg-blue-500 px-2 py-1 mx-2 rounded border-2  border-black" @click="Verificar('RECHAZADA')">Rechazar</button>
                    -->
                  <!--  <button class=" bg-blue-500 px-2 py-1 mx-2 rounded border-2  border-black" @click="viewCotizacion=false">Cerrar</button>-->
                    <btn_component :text="'Cerrar'" :tipo="'info'"   @click="viewCotizacion=false"></btn_component>
                    
                </div>
            </template>
        </el-drawer>
    
    </section>
    </template>
    
    <script>
    import {
        emitter
    } from "../../../mitt.js";
    import {
        useUserStore
    } from '../../../stores/user'
    import Tabla from "@/components/Tabla.vue";
    import TemplateCotizacion from "@/components/TemplateCotizacion.vue";
    import generales from "@/functions/generales";
    import metodos_pagos from "@/Services/metodos_pagos";
    import abonos from "@/Services/abonos";
    import cotizaciones from "@/Services/cotizaciones";
    
    import VistaAprobacion from "@/components/VistaAprobacion.vue";
    import {
        filter
    } from "lodash";
    export default {
        components: {
            Tabla,
            VistaAprobacion
        },
        mixins: [generales, cotizaciones, metodos_pagos, abonos],
        data() {
            const user = useUserStore()
    
            return {
                headings: [
    
                    {
                        key: 'id',
                        name: '# Cot',
                        show: true
                    },
                    {
                        key: 'idventa',
                        name: '# venta',
                        show: true
                    },
                    {
                        key: 'venta',
                        name: 'Fecha venta',
                        show: true
                    },
    
                    {
                        key: 'clientes',
                        name: 'Cliente',
                        show: true
                    },
    
                    {
                        key: 'usuario',
                        name: 'Usuario',
                        show: true
                    },
                    {
    
                        key: 'verificar_aprobar',
                        name: 'Verificar',
                        show: true
                    },
    
                    /* {
                         key: 'edit',
                         name: 'Editar',
                         show: true
                     },*/
    
                ],
                dates: [],
                upbuton: 0,
                el_cotizacion: {
                    id: 0
                },
                open: false,
                user: user.getAll(),
                metodos_data: [],
                data: {},
                actionModal: null,
                viewCotizacion: false,
                showM: false,
                info: '',
                id: 0,
                obj_abono: {
                    cotizacion: 0,
                    tipo_pago: '',
                    impuesto: 0,
                    comision: 0,
                    total: 0,
                },
                addAbono: false,
                tipo_metodo: null,
                buscar: 'all',
                pagina: 1,
                limit: 0,
                reftable: 0,
                tipo: 'verificar',
                fecha: [this.getFirstDayOfMonth(), this.getLastDayOfMonth()],
                
                // Nuevas variables para filtros de fecha avanzados
                fechaRango: [this.getFirstDayOfMonth(), this.getLastDayOfMonth()],
                tipoFiltroFecha: 'mes', // 'mes' o 'personalizado'
                mesSeleccionado: this.getCurrentYearMonth(),
                fechaInicioPersonalizada: this.formatDateEN(this.getFirstDayOfMonth()),
                fechaFinPersonalizada: this.formatDateEN(this.getLastDayOfMonth()),
    
            }
    
        },
        mounted() {
    
        },
        async created() {
            if (this.$route.query.hasOwnProperty('cid')) {
                this.buscar = this.$route.query.cid;
                
                // Cuando hay parámetro cid, usar rango amplio (desde enero del año actual)
                const now = new Date();
                const primeroDEnero = new Date(now.getFullYear(), 0, 1); // 1 de enero del año actual
                const fechaActual = new Date(); // Fecha actual
                
                this.fechaRango = [primeroDEnero, fechaActual];
                this.fecha = [primeroDEnero, fechaActual];
                
                // Configurar filtro personalizado
                this.tipoFiltroFecha = 'personalizado';
                this.fechaInicioPersonalizada = this.formatDateEN(primeroDEnero);
                this.fechaFinPersonalizada = this.formatDateEN(fechaActual);
                
                console.log('🔍 Parámetro CID detectado:', this.buscar, 'Usando rango amplio:', primeroDEnero, 'a', fechaActual);
                
                // Cargar datos directamente con el rango amplio
                this.getData();
            } else {
                // Aplicar filtro de mes actual por defecto cuando no hay CID
                this.aplicarFiltroMes();
            }
            
            await this.getDataMetodos();
        },
        methods: {
            IsMov() {
    
                //return true;
                return this.$isMobile()
            },
            verCotizacion(row) {
    
                this.el_cotizacion = row;
                this.viewCotizacion = true;
    
            },
            async pageChangue(val) {
    
                this.page = val;
                await this.getData();
    
            },
    
            infoModal(row) {
                this.info = row;
               
            },
            paginaSearch(pagina) {
                
                this.pagina = pagina;
    
                this.getData();
            },
    
            addRow() {
                this.showM = !this.showM;
                this.limpiar()
            },
            limpiar() {
                this.viewCotizacion = false;
            },
            buscador(row) {
                if (String(row.telefono).toUpperCase().search(String(this.buscar).toUpperCase()) != -1 || (String(row.nombre)).toUpperCase().search(String(this.buscar).toUpperCase()) != -1) {
                    return true;
                } else {
                    return false;
                }
            },
            getColumns() {
                let col = 0;
                this.headings.forEach(element => {
                    if (element.show) {
                        col = col + 1
                    }
                });
                return col;
            },
    
            buscarGet(text) {
                this.buscar = text;
                if (text == '') {
                    this.buscar = 'all';
                }
                this.getData();
            },
    
            async getData() {
                this.showM = false;
                this.actionModal = null;
                emitter.emit("loading", true)
                let dat = {
                    search: this.buscar,
                    page: this.pagina,
                    tipo: this.tipo,
                    inicio: this.formatDateEN(this.fechaRango[0]),
                    fin: this.formatDateEN(this.fechaRango[1]),
                    data: {}
                }
                
                console.log('📊 Cargando datos de aprobación con filtros:', dat);
    
                await cotizaciones.GET(dat).then(response => {
    
                    if (response != null && !response.hasOwnProperty('error')) {
    
                        this.data = response;
                        console.log('✅ Datos cargados correctamente:', response.data?.length || 0, 'registros');
    
                        if (this.$route.query.hasOwnProperty('cid')) {
                            let fresult = response.data.filter(r => r.id == this.$route.query.cid)
    
                            if (fresult.length > 0) {
                                this.$router.replace({
                                    name: 'detalle_verificar',
                                    force: true
                                });
                                this.el_cotizacion = fresult[0];
                                this.viewCotizacion = true;
                            }
                        
                        }
                        this.reftable = this.reftable + 1;
    
                        //this.$router.push('/app/'); 
                    } else {
    
                        emitter.emit("alerta_show", response.error);
    
                    }
                    emitter.emit("loading", false)
                });
            },
    
            async Verificar(status) {
    
                let dat = {
                    id: this.el_cotizacion.id,
                    status_verificar: status,
                    observaciones_verificar: this.el_cotizacion.observaciones_verificar
    
                }
                if (status == 'APROBADA') {
                    dat.status_produccion = 'EN PRODUCCION'
                }
    
                if (this.el_cotizacion.id == 0) {
                    //this.crear(dat)
                } else {
                    this.editar(dat)
                }
            },
    
            async editar(dat) {
                emitter.emit("loading", true)
    
                await cotizaciones.EDITAR_PARAMS(dat).then(response => {
    
                    if (response != null && !response.hasOwnProperty('error')) {
    
                        this.el_cotizacion = response;
                        //this.$router.push('/app/'); 
                    } else {
    
                        // emitter.emit("alerta_show",response.msg);
    
                    }
                    this.showM = false;
                    this.limpiar();
                    emitter.emit("loading", false)
                });
            },

            // ===== MÉTODOS PARA FILTROS DE FECHA AVANZADOS =====
            getCurrentYearMonth() {
                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                return `${year}-${month}`;
            },

            formatDateES(date) {
                if (!date) return '';
                const d = new Date(date);
                return d.toLocaleDateString('es-ES');
            },
            
            cambiarTipoFiltro() {
                console.log('🔄 Cambiando tipo de filtro a:', this.tipoFiltroFecha);
                if (this.tipoFiltroFecha === 'mes') {
                    this.aplicarFiltroMes();
                } else {
                    this.aplicarFiltroPersonalizado();
                }
            },
            
            aplicarFiltroMes() {
                if (!this.mesSeleccionado) return;
                
                const [year, month] = this.mesSeleccionado.split('-');
                const firstDay = new Date(year, month - 1, 1);
                const lastDay = new Date(year, month, 0);
                
                this.fechaRango = [firstDay, lastDay];
                this.fecha = [firstDay, lastDay]; // Mantener compatibilidad
                console.log('📅 Aplicando filtro por mes:', this.mesSeleccionado, 'Rango:', firstDay, 'a', lastDay);
                this.getData();
            },
            
            aplicarFiltroPersonalizado() {
                if (!this.fechaInicioPersonalizada || !this.fechaFinPersonalizada) return;
                
                const fechaInicio = new Date(this.fechaInicioPersonalizada);
                const fechaFin = new Date(this.fechaFinPersonalizada);
                
                // Validar que la fecha de inicio no sea mayor que la fecha fin
                if (fechaInicio > fechaFin) {
                    alert('La fecha de inicio no puede ser mayor que la fecha de fin');
                    return;
                }
                
                this.fechaRango = [fechaInicio, fechaFin];
                this.fecha = [fechaInicio, fechaFin]; // Mantener compatibilidad
                console.log('📅 Aplicando filtro personalizado:', fechaInicio, 'a', fechaFin);
                this.getData();
            },
            
            establecerMesActual() {
                this.tipoFiltroFecha = 'mes';
                this.mesSeleccionado = this.getCurrentYearMonth();
                this.aplicarFiltroMes();
            },
            
            establecerMesAnterior() {
                const now = new Date();
                const mesAnterior = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                const year = mesAnterior.getFullYear();
                const month = String(mesAnterior.getMonth() + 1).padStart(2, '0');
                
                this.tipoFiltroFecha = 'mes';
                this.mesSeleccionado = `${year}-${month}`;
                this.aplicarFiltroMes();
            },
            
            establecerUltimos3Meses() {
                const now = new Date();
                const hace3Meses = new Date(now.getFullYear(), now.getMonth() - 2, 1);
                const finMesActual = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                
                this.tipoFiltroFecha = 'personalizado';
                this.fechaInicioPersonalizada = this.formatDateEN(hace3Meses);
                this.fechaFinPersonalizada = this.formatDateEN(finMesActual);
                this.aplicarFiltroPersonalizado();
            },
            // ===== FIN MÉTODOS PARA FILTROS DE FECHA =====
    
        }
    }
    </script>
    